module.exports = __webpack_public_path__ + "img/25.ebcc68fe.png";